"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cutlery = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var Switch_1 = require("../Switch");
var actions_1 = require("../../store/cart/actions");
var Cutlery = function () {
    var t = (0, react_i18next_1.useTranslation)().t;
    var dispatch = (0, react_redux_1.useDispatch)();
    var cutleryCount = (0, react_redux_1.useSelector)(function (state) { return ({
        cutleryCount: state.cart.cutleryCount,
    }); }).cutleryCount;
    var isCutleryChecked = cutleryCount === 1;
    var onSwitchCutlery = function () { return dispatch((0, actions_1.cartChangeAttribute)('cutleryCount', cutleryCount === 1 ? 0 : 1)); };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "checkout-basket-pickup-cutlery" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "checkout-basket-pickup-cutlery-header" }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: "checkout-basket-pickup-cutlery-header-title" }, { children: t('Would you like to add cutlery?') })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "checkout-basket-pickup-cutlery-header-switch" }, { children: (0, jsx_runtime_1.jsx)(Switch_1.Switch, { checked: isCutleryChecked, onChange: onSwitchCutlery }) }))] })), (0, jsx_runtime_1.jsx)("span", __assign({ className: "checkout-basket-pickup-cutlery-help" }, { children: isCutleryChecked ? t('The restaurant will add cutlery for you if available') : t('Help reduce waste, only request if needed') }))] })));
};
exports.Cutlery = Cutlery;
